<template>
  <a class="item" @click="onClick(index, change, $el.offsetTop, $el.offsetHeight)">
    <div class="ui grid">
      <div class="row" style="margin: 5px;">
        <div class="eight wide column" :title="relativeTime(change.ts)">
          <span style="font-weight: bold;">{{ relativeTime(change.ts) }}</span>
        </div>
        <div
          class="eight wide right aligned column"
          :title="formatDate(change.ts)"
          style="color: gray;"
        >
          {{ formatDate(change.ts) }}
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <profile-icon :user="user" />
          <span class="ellipsis">{{ change.context.author }}</span>
        </div>
        <div class="ten wide right aligned column">
          <change-label
            class="tagnameLabel"
            :change="change"
            :tagnameFocused="tagnameFocused"
            :removeTag="removeTag"
            v-if="change.tagname && !tagnameFocused"
          />

          <button
            class="ui mini icon button"
            v-if="!change.tagname && !tagnameFocused"
            :disabled="isEditDisabled"
            @click.prevent.stop="showTagnameInput"
          >
            <i class="icon tag"></i>
          </button>
          <div class="ui input" v-if="tagnameFocused">
            <input
              ref="tagnameInput"
              v-model="change.tagname"
              type="text"
              :placeholder="$t('ENTER_TAG')"
              @click.prevent.stop="() => {}"
              @keydown.enter.prevent="onEnterInTagnameInput(change)"
              @blur="onTagnameInputBlur(change)"
              @focus="onTagnameInputFocus()"
            />
          </div>
          <button
            class="ui mini icon button"
            @click.prevent.stop="revertToChange(change)"
            :disabled="isEditDisabled"
            v-if="!change.isCurrent && !tagnameFocused"
          >
            <i class="icon history"></i>
          </button>
        </div>
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.active {
  background-color: #e0e2e4 !important;
}

.ellipsis {
  height: 90%;
}

.ui.label {
  vertical-align: top;
}

.tagnameLabel {
  max-width: 60%;
}
</style>
<script>
// @flow
import moment from 'moment'
import ChangeLabel from './ChangeLabel'
import ProfileIcon from '../Users/ProfileIcon.vue'

export default {
  name: 'single-change',
  components: { ProfileIcon, ChangeLabel },
  props: {
    index: {
      type: Number,
      default: () => 0
    },
    change: {
      type: Object,
      default: () => null
    },
    onClick: {
      type: Function,
      default: () => ''
    },
    tagChange: {
      type: Function,
      default: () => ''
    },
    removeTag: {
      type: Function,
      default: () => ''
    },
    revertToChange: {
      type: Function,
      default: () => ''
    },
    isEditDisabled: {
      type: Boolean,
      default: () => false
    },
    user: {
      type: Object,
      default: () => undefined
    }
  },
  data() {
    return {
      tagnameFocused: false
    }
  },
  computed: {
    currentLang() {
      return this.$locale.current()
    }
  },
  methods: {
    formatDate(ts) {
      return moment(new Date(0).setUTCSeconds(ts))
        .locale(this.currentLang)
        .format('DD/MM/YYYY HH:mm')
    },
    relativeTime(ts) {
      return moment(new Date(0).setUTCSeconds(ts))
        .locale(this.currentLang)
        .fromNow()
    },
    onTagnameInputFocus() {
      this.tagnameFocused = true
    },
    onTagnameInputBlur(change) {
      if (this.tagnameFocused) {
        this.changeTagname(change)
      }
      this.tagnameFocused = false
    },
    onEnterInTagnameInput(change) {
      if (this.tagnameFocused) {
        this.changeTagname(change)
        this.tagnameFocused = false
      }
    },
    changeTagname(change) {
      this.tagChange(change)
    },
    showTagnameInput() {
      this.tagnameFocused = true
      this.$nextTick(() => {
        this.$refs.tagnameInput.focus()
      })
    }
  }
}
</script>
